<script setup lang="ts">
    import { api } from '@cwd/lib/main';
    import { onMounted, reactive, computed, watch } from 'vue';
    import Modal from '@shared/components/Modal.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';
    import Alert from '@shared/components/BsAlert.vue';
    import { ExecutionHistoryReference } from '../journeys';
    import { GetJourneyExecutionHistory } from '../Journey.access';

    const props = defineProps<{
        journeyId: string | null;
        show: boolean;
    }>();

    const state = reactive({
        executionHistory: [] as ExecutionHistoryReference[],
    });

    onMounted(async () => {
        getExecutionHistory(props.journeyId);

        watch(
            () => props.journeyId,
            async (newVal) => {
                getExecutionHistory(newVal);
            }
        );
    });

    const getExecutionHistory = async (newVal: string | null) => {
        if (!newVal) return;
        state.executionHistory = await GetJourneyExecutionHistory(newVal);
    };

    const formattedDates = computed(() => {
        return state.executionHistory.map((item: ExecutionHistoryReference) => {
            const date = new Date(item.Scheduled);
            return {
                original: item.Scheduled,
                dateString: date.toLocaleDateString(navigator.language, { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' }),
                timeString: date.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
            };
        });
    });
</script>

<template>
    <Modal :show="show" :title="$Resources.ExecutionHistoryHeading" @close="$emit('close')">
        <template #content>
            <template v-if="state.executionHistory?.length > 0">
                <Alert
                    :show="true"
                    :type="AlertTypes.Info"
                    :title="$Resources.ExecutionHistoryInfoHeading"
                    :content="$Resources.ExecutionHistoryInfoBody"
                    :dismissible="false"></Alert>

                <ol class="list-unstyled list-border-divider list-item-state-hover">
                    <li class="d-flex justify-content-between p-sm" v-for="formatted of formattedDates" :key="formatted.original">
                        {{ formatted.dateString }}
                        <time>
                            {{ formatted.timeString }}
                        </time>
                    </li>
                </ol>
            </template>
            <template v-else>
                <Alert
                    :show="true"
                    :type="AlertTypes.Info"
                    :title="$Resources.GeneralErrorAlertHeading"
                    :content="$Resources.NoExecutionHistoryAlert"
                    :dismissible="false"></Alert>
            </template>
        </template>
    </Modal>
</template>
